import { render, staticRenderFns } from "./course-list.vue?vue&type=template&id=363419e4&scoped=true&"
import script from "./course-list.vue?vue&type=script&lang=js&"
export * from "./course-list.vue?vue&type=script&lang=js&"
import style0 from "./course-list.scss?vue&type=style&index=0&id=363419e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363419e4",
  null
  
)

export default component.exports